<template>
  <FormBase>
    <div class="form-element">
      <label for="senderFirstname">Jouw voornaam</label>
      <input
        @input="onFieldChange"
        id="senderFirstname"
        type="text"
        :placeholder="errorMap['senderFirstname']"
        :value="jouwData.senderFirstname"
        :class="[
          {
            'has-errors': dataErrors.senderFirstname,
            'has-content': jouwData.senderFirstname,
          },
        ]"
      />
      <Icon
        name="alert"
        class="error-label"
        v-if="dataErrors.senderFirstname"
      />
    </div>
    <div class="form-element">
      <label for="senderLastname">Jouw achternaam</label>
      <input
        @input="onFieldChange"
        id="senderLastname"
        type="text"
        :placeholder="errorMap['senderLastname']"
        :value="jouwData.senderLastname"
        :class="[
          {
            'has-errors': dataErrors.senderLastname,
            'has-content': jouwData.senderLastname,
          },
        ]"
      />
      <Icon name="alert" class="error-label" v-if="dataErrors.senderLastname" />
    </div>

    <div class="form-element">
      <label for="senderEmail">Jouw email</label>
      <input
        @input="onFieldChange"
        id="senderEmail"
        type="text"
        :placeholder="errorMap['senderEmail']"
        :value="jouwData.senderEmail"
        @paste.prevent
        :class="[
          {
            'has-errors': dataErrors.senderEmail,
            'has-content': jouwData.senderEmail,
          },
        ]"
      />
      <Icon name="alert" class="error-label" v-if="dataErrors.senderEmail" />
    </div>

    <div class="form-element">
      <label for="bevestigEmail">Bevestig email</label>
      <input
        @input="onFieldChange"
        id="bevestigEmail"
        type="text"
        :placeholder="errorMap['bevestigEmail']"
        :value="jouwData.bevestigEmail"
        @paste.prevent
        :class="[
          {
            'has-errors': dataErrors.bevestigEmail,
            'has-content': jouwData.bevestigEmail,
          },
        ]"
      />
      <Icon name="alert" class="error-label" v-if="dataErrors.bevestigEmail" />
    </div>

    <div class="form-element">
      <label for="schiftingsVraag" class="show-label"
        >Hoeveel mensen zullen de code deze week juist ingevuld hebben?</label
      >
      <input
        @input="onFieldChange"
        id="schiftingsVraag"
        type="text"
        :placeholder="errorMap['schiftingsVraag']"
        v-model="jouwData.schiftingsVraag"
        v-mask="'########'"
        :class="[
          {
            'has-errors': dataErrors.schiftingsVraag,
            'has-content': jouwData.schiftingsVraag,
          },
        ]"
      />
      <Icon
        name="alert"
        class="error-label"
        v-if="dataErrors.schiftingsVraag"
      />
    </div>
    <div class="checks">
      <label for="senderOptin" class="checkmark-container">
        <input
          @input="onFieldChange"
          type="checkbox"
          id="senderOptin"
          name="senderOptin"
          :checked="jouwData.senderOptin"
        />
        <span class="checkmark"></span>
        <span class="label-text">
          Ik ontvang graag de wekelijkse VTM-nieuwsbrief vol nieuwe programma's,
          exclusieve video's, leuke wedstrijden en uitnodigingen.
        </span>
      </label>
    </div>
    <div class="privacy-text">
      Door verder te gaan, ga je akkoord met de
      <a
        href="https://www.dpgmedia.be/nl/algemene-voorwaarden"
        target="_blank"
        rel="noopener noreferrer"
      >
        Gebruiksvoorwaarden
      </a>
      en erken je het
      <a
        href="https://www.dpgmedia.be/nl/privacy"
        target="_blank"
        rel="noopener noreferrer"
        >Privacybeleid</a
      >
      te hebben gelezen.
    </div>
  </FormBase>
</template>

<script>
import FormBase from './components/FormBase';
import { mapMutations, mapState } from 'vuex';
import { errorMap } from '@/components/Kamer';
import Icon from '@/components/Icon';

export default {
  name: 'JouwForm',
  data() {
    return {
      errorMap,
    };
  },
  components: { Icon, FormBase },
  computed: {
    ...mapState(['jouwData', 'errors']),
    dataErrors() {
      return this.errors || {};
    },
  },
  methods: {
    ...mapMutations(['setJouwData']),
    onFieldChange(e) {
      this.setJouwData({
        name: e.target.id,
        value: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.privacy-text {
  text-align: left;
  font-size: 14px;
  margin-top: 20px;
}

// Custom checkbox styling:
.checks {
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  label {
    text-align: left;
    margin: 0;
    padding: 0;
    display: flex;
    flex: 1;
    flex-direction: row;
    border-radius: 50%;
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }
    .checkmark {
      position: relative;
      display: flex;
      height: 24px;
      width: 24px;
      border: 2px solid #979797;
      justify-content: center;
      flex-shrink: 0;
      border-radius: 50%;

      &:after {
        align-self: center;
        height: 12px;
        width: 12px;
        background-color: transparent;
        content: ' ';
        transition: background-color 0.5s;
        border-radius: 50%;
      }
    }
    .label-text {
      padding-left: 10px;
      display: flex;
      flex: 1;
      font-weight: normal;
      margin-top: 2px;
    }
    input:checked ~ .checkmark:after {
      transition: background-color 0.5s;
      background-color: black;
    }
  }
}
.error-label {
  right: 0;
  position: absolute;
  transform: translate(-10px, 12px);
}
</style>
